import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { format } from "date-fns";
import { Tabs, Tab } from "react-bootstrap";
import { config, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Quotation = () => {
  const [quotations, setQuotations] = useState(null);
  const [tableFilters, setTableFilters] = useState(null);
  const [tableSearch, setTableSearch] = useState('');
  const [tableSortBy, setTableSortBy] = useState('quotation_code');
  const [tableSortType, setTableSortType] = useState('descending');
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const searchInputRef = useRef(null);

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    setTableFilters({
      quotationStatus: 'Draft',
      quotationCreatedBy: crmUser.user_level === 'User' && crmUser.user_department === 'Sales' ? [crmUser.user_keyid] : []
    });
    getQuotations();
  }, []);

  const getQuotations = async () => {
    try {
      let requestQuotation = {
        created_bys:
          crmUser.user_level === 'User' && crmUser.user_department === 'Sales'
            ? [crmUser.user_keyid]
            : [],
      };
      const fetchQuotations = await jwtFetch(config.ENDPOINT + 'get/quotation_table', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestQuotation)
      });
      let responseQuotations = await fetchQuotations.json();
      if (responseQuotations.status === 200) {
        for (let i in responseQuotations.data) {
          responseQuotations.data[i].quotation_labels = responseQuotations.data[i].quotation_status === 'Open' && responseQuotations.data[i].quotation_approval;
          responseQuotations.data[i].quotation_labels += responseQuotations.data[i].quotation_status === 'Won' && responseQuotations.data[i].so_status === null ? 'SO Not Created' : '';
          responseQuotations.data[i].quotation_labels += responseQuotations.data[i].quotation_status === 'Won' && responseQuotations.data[i].so_status === 'In Progress' ? 'SO In Progress' : '';
          responseQuotations.data[i].quotation_labels += responseQuotations.data[i].iou_term_count && responseQuotations.data[i].iou_term_count === responseQuotations.data[i].iou_last_paid ? 'Paid in Full' : ('Schedule' + (responseQuotations.data[i].iou_last_issued ? responseQuotations.data[i].iou_last_issued.replace('Term ', '') : '1') + ' of ' + (responseQuotations.data[i].iou_term_count ? responseQuotations.data[i].iou_term_count.replace('Term ', '') : ''));

          if (responseQuotations.data[i].quotation_status === 'Freeze') {
            responseQuotations.data[i].quotation_status = 'Expire';
            responseQuotations.data[i].quotation_labels = 'Freeze';
          }

          if (responseQuotations.data[i].quotation_status === 'Open' && responseQuotations.data[i].quotation_approval !== 'Draft' && responseQuotations.data[i].quotation_approval !== 'Approved') {
            if (responseQuotations.data[i].quotation_approval === 'Rejected') {
              responseQuotations.data[i].quotation_status = 'Rejected';
              responseQuotations.data[i].quotation_labels = '';
            } else {
              responseQuotations.data[i].quotation_status = 'Pending Approval';
              responseQuotations.data[i].quotation_labels = responseQuotations.data[i].quotation_approval;
            }
          }

          let searchData = String(responseQuotations.data[i].quotation_code ?? '').toLowerCase();
          searchData += String(responseQuotations.data[i].company_name ?? '').toLowerCase();
          searchData += String(responseQuotations.data[i].company_billing_name ?? '').toLowerCase();
          searchData += responseQuotations.data[i].subcompany_name ? responseQuotations.data[i].subcompany_name.toLowerCase() : '';
          searchData += responseQuotations.data[i].subcompany_billing_name ? responseQuotations.data[i].subcompany_billing_name.toLowerCase() : '';
          searchData += responseQuotations.data[i].item_list_names ? responseQuotations.data[i].item_list_names.toLowerCase() : '';
          searchData += responseQuotations.data[i].item_list_tagging ? responseQuotations.data[i].item_list_tagging.toLowerCase() : '';
          searchData += String(responseQuotations.data[i].sales_name ?? '').toLowerCase();
          searchData += responseQuotations.data[i].quotation_labels ? responseQuotations.data[i].quotation_labels.toLowerCase() : '';
          responseQuotations.data[i].search = searchData;
        }
        setQuotations(responseQuotations.data);
        setIsLoadingPage(false);
      } else {
        alert(responseQuotations.message);
      }
    } catch (error) {
      console.error('Error in getQuotations:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const filterTable = (key, value) => {
    let filters = { ...tableFilters };
    if (key === 'status') {
      filters.quotationStatus = value;
    }
    if (key === 'createdBy') {
      if (filters.quotationCreatedBy.includes(value)) {
        filters.quotationCreatedBy = filters.quotationCreatedBy.filter(item => item !== value);
      } else {
        filters.quotationCreatedBy.push(value);
      }
    }
    setTableFilters(filters);
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  const getStatusCount = (status) => {
    if (!quotations) return 0;
    // return quotations.filter(quotation => 
    //   quotation.quotation_status === status && 
    //   (tableSearch === '' || quotation.search.includes(tableSearch.toLowerCase()))
    // ).length;
    return quotations.filter(quotation =>
      quotation.quotation_status === status &&
      (tableSearch === '' || quotation.search.includes(tableSearch.toLowerCase())) &&
      (crmUser.user_level === 'User' && crmUser.user_department === 'Sales' ?
        [crmUser.user_keyid].includes(quotation.created_by) :
        true
      )
    ).length;
  }

  return (
    <div id="quotation-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="quotation" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">Quotation List</div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg" /> : <i className="bi bi-search" />}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value.trim())} ref={searchInputRef} autoFocus />
                      </div>
                      {crmUser.user_department !== 'Sales Admin' && crmUser.user_level !== 'View' && (
                        <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/quotation/add'} target="_blank" rel="noreferrer"><i className="bi bi-plus-circle me-1" /> Add</button>
                      )}
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    <Tabs className="mb-3" defaultActiveKey="Draft" onSelect={(key) => filterTable('status', key)}>
                      <Tab eventKey="Draft" title={`Draft${getStatusCount('Draft') > 0 ? ` (${getStatusCount('Draft')})` : ''}`} />
                      <Tab eventKey="Pending Approval" title={`Pending Approval${getStatusCount('Pending Approval') > 0 ? ` (${getStatusCount('Pending Approval')})` : ''}`} />
                      <Tab eventKey="Open" title={`Open${getStatusCount('Open') > 0 ? ` (${getStatusCount('Open')})` : ''}`} />
                      <Tab eventKey="Won" title={`Won${getStatusCount('Won') > 0 ? ` (${getStatusCount('Won')})` : ''}`} />
                      <Tab eventKey="Expire" title={`Expired${getStatusCount('Expire') > 0 ? ` (${getStatusCount('Expire')})` : ''}`} />
                      <Tab eventKey="Rejected" title={`Rejected${getStatusCount('Rejected') > 0 ? ` (${getStatusCount('Rejected')})` : ''}`} />
                      <Tab eventKey="Canceled" title={`Cancelled${getStatusCount('Canceled') > 0 ? ` (${getStatusCount('Canceled')})` : ''}`} />
                      <Tab eventKey="Lost" title={`Lost${getStatusCount('Lost') > 0 ? ` (${getStatusCount('Lost')})` : ''}`} />
                    </Tabs>
                    {quotations && quotations.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold w-40">#</th>
                              <th className="bg-gold w-140 pointer" onClick={() => sortTable('quotation_code')}>Number {tableSortBy === 'quotation_code' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-105 pointer" onClick={() => sortTable('quotation_labels')}>Label {tableSortBy === 'quotation_labels' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('company_name')}>Company Name {tableSortBy === 'company_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-150 pointer text-start" onClick={() => sortTable('sales_name')}>Sales Name {tableSortBy === 'sales_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-125 pointer text-end" onClick={() => sortTable('quotation_total')}>Amount {tableSortBy === 'quotation_total' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-40"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {[...quotations]
                              .sort((a, b) => {
                                const aValue = a[tableSortBy];
                                const bValue = b[tableSortBy];
                                const aNum = Number(aValue);
                                const bNum = Number(bValue);
                                const isNumeric = !isNaN(aNum) && !isNaN(bNum);
                                if (isNumeric) {
                                  return tableSortType === 'ascending' ? aNum - bNum : bNum - aNum;
                                }
                                return tableSortType === 'ascending'
                                  ? (aValue ?? '').toString().localeCompare((bValue ?? '').toString())
                                  : (bValue ?? '').toString().localeCompare((aValue ?? '').toString());
                              })
                              .filter(quotation => quotation.search.includes(tableSearch.toLowerCase()))
                              .filter(quotation => {
                                if (tableFilters && tableFilters.quotationStatus) {
                                  return quotation.quotation_status === tableFilters.quotationStatus;
                                }
                                return true;
                              })
                              .filter(quotation => {
                                if (tableFilters) {
                                  if (tableFilters.quotationCreatedBy && tableFilters.quotationCreatedBy.length > 0) {
                                    return tableFilters.quotationCreatedBy.includes(quotation.created_by);
                                  }
                                  return true;
                                }
                                return true;
                              })
                              .map((quotation, q) => (
                                <tr key={"quotation-" + q}>
                                  <td valign="middle" align="center">{q + 1}</td>
                                  <td valign="middle" align="center">{quotation.quotation_code}</td>
                                  <td valign="middle" align="center">
                                    {/* <span className={"badge text-bg-" + (quotation.quotation_status === 'Won' ? 'success' : ((quotation.quotation_status === 'Canceled' || quotation.quotation_status === 'Lost') ? 'danger' : 'secondary'))}>{quotation.quotation_status}</span> */}
                                    {quotation.quotation_status === 'Draft' && (
                                      <span className="badge ms-1 text-bg-secondary">Draft</span>
                                    )}
                                    {quotation.quotation_status === 'Open' && (
                                      <span className={"badge ms-1 text-bg-" + (quotation.quotation_approval === 'Approved' ? 'success' : (quotation.quotation_approval === 'Rejected' ? 'danger' : 'secondary'))}>{quotation.quotation_approval}</span>
                                    )}
                                    {quotation.quotation_status === 'Expire' && (
                                      quotation.quotation_labels === 'Freeze' ? (
                                        <span className="badge ms-1 text-bg-secondary">Freeze</span>
                                      ) : (
                                        <span className="badge ms-1 text-bg-danger">Expired</span>
                                      )
                                    )}
                                    {quotation.quotation_status === 'Won' && quotation.so_status === null && (
                                      <span className="badge ms-1 text-bg-warning">SO Not Created</span>
                                    )}
                                    {quotation.quotation_status === 'Won' && quotation.so_status === 'In Progress' && (
                                      <span className="badge ms-1 text-bg-warning">SO In Progress</span>
                                    )}
                                    {quotation.iou_term_count && (
                                      quotation.iou_term_count === quotation.iou_last_paid ? (
                                        <span className="badge ms-1 text-bg-success">Paid in Full</span>
                                      ) : (
                                        <span className="badge ms-1 text-bg-info">Schedule {quotation.iou_last_issued ? quotation.iou_last_issued.replace('Term ', '') : '1'} of {quotation.iou_term_count.replace('Term ', '')}</span>
                                      )
                                    )}
                                    {quotation.quotation_status === 'Pending Approval' && (
                                      <span className="badge ms-1 text-bg-warning">Pending Approval</span>
                                    )}
                                    {quotation.quotation_status === 'Rejected' && (
                                      <span className="badge ms-1 text-bg-danger">Rejected</span>
                                    )}
                                    {quotation.quotation_status === 'Canceled' && (
                                      <span className="badge ms-1 text-bg-danger">Cancelled</span>
                                    )}
                                    {quotation.quotation_status === 'Lost' && (
                                      <span className="badge ms-1 text-bg-danger">Lost</span>
                                    )}
                                  </td>
                                  <td valign="middle">
                                    <strong>{quotation.company_name}</strong>
                                    <br />
                                    <small>{quotation.subcompany_billing_name}</small>
                                  </td>
                                  <td valign="middle">
                                    {quotation.sales_name}
                                    <br />
                                    <small>Created on {format(quotation.initial_date, 'd MMM yyyy')}</small>
                                  </td>
                                  <td valign="middle" align="right">{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</td>
                                  <td valign="middle" align="right"><a className="btn btn-sm bg-gold" href={'/quotation/detail/' + quotation.id_quotation}><i className="bi bi-eye" /></a></td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quotation;

